import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc9de27c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail" }
const _hoisted_2 = { class: "detail-title" }
const _hoisted_3 = { class: "detail-content" }
const _hoisted_4 = { class: "item first" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "copy" }
const _hoisted_12 = {
  id: "detailVal1",
  style: {"width":"0","height":"0","opacity":"0"}
}
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = {
  key: 0,
  class: "content"
}
const _hoisted_16 = {
  key: 0,
  class: "status-container"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "2em",
  height: "2em",
  fill: "currentColor",
  class: "bi bi-check-circle-fill mr4",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z",
    fill: "#088A00"
  })
], -1))
const _hoisted_18 = { class: "text-container" }
const _hoisted_19 = { class: "text-success" }
const _hoisted_20 = {
  key: 1,
  class: "status-container"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "warning-tag mr4",
  viewBox: "64 64 896 896",
  focusable: "false",
  "data-icon": "exclamation-circle",
  width: "2em",
  height: "2em",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z",
    fill: "rgb(218, 67, 67)"
  })
], -1))
const _hoisted_22 = { class: "text-container" }
const _hoisted_23 = { class: "text-failed" }
const _hoisted_24 = { class: "item" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "item" }
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { class: "content" }
const _hoisted_30 = { class: "text" }
const _hoisted_31 = { class: "item" }
const _hoisted_32 = { class: "title" }
const _hoisted_33 = { class: "content" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "text" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "text" }
const _hoisted_38 = { class: "copy" }
const _hoisted_39 = {
  id: "detailVal2",
  style: {"width":"0","height":"0","opacity":"0"}
}
const _hoisted_40 = { class: "item" }
const _hoisted_41 = { class: "title" }
const _hoisted_42 = { class: "content" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "text" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "text" }
const _hoisted_47 = { class: "copy" }
const _hoisted_48 = {
  id: "detailVal3",
  style: {"width":"0","height":"0","opacity":"0"}
}
const _hoisted_49 = { class: "item" }
const _hoisted_50 = { class: "title" }
const _hoisted_51 = { class: "content" }
const _hoisted_52 = { class: "text" }
const _hoisted_53 = { class: "item" }
const _hoisted_54 = { class: "title" }
const _hoisted_55 = { class: "content" }
const _hoisted_56 = { class: "text" }
const _hoisted_57 = {
  key: 0,
  class: "item"
}
const _hoisted_58 = { class: "title" }
const _hoisted_59 = { class: "content" }
const _hoisted_60 = { class: "address" }
const _hoisted_61 = { class: "detail-item" }
const _hoisted_62 = { class: "title" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "text link" }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = { class: "text link" }
const _hoisted_68 = { key: 2 }
const _hoisted_69 = { class: "text link" }
const _hoisted_70 = { class: "detail-item" }
const _hoisted_71 = { class: "title" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "text link" }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = { class: "text link" }
const _hoisted_77 = { key: 2 }
const _hoisted_78 = { class: "text link" }
const _hoisted_79 = { class: "amount" }
const _hoisted_80 = { class: "detail-item" }
const _hoisted_81 = {
  class: "title",
  style: {"width":"auto"}
}
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "text" }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { class: "detail-item" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { class: "text link" }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { class: "text link" }
const _hoisted_92 = { key: 2 }
const _hoisted_93 = { class: "text link" }

import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getTx } from "@/api/_common";
import Title from "@/components/SecondaryTitle.vue";
import Clipboard from "clipboard";
import { useMq } from "vue3-mq";
import HelperTools from "@/utils/helper";
import t from "@/utils/en";
import { ElMessage } from "element-plus";
import { ElIcon } from "element-plus";
import { ArrowRight, ArrowLeft, CopyDocument } from "@element-plus/icons";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tx = ref<any>({});
const IsLoading = ref(true);

const isMdOrSm = computed(() => {
  const mq = useMq();
  return mq.current === "md" || mq.current === "sm";
});
const isSmOrXs = computed(() => {
  const mq = useMq();
  return mq.current === "sm" || mq.current === "xs";
});
const isXs = computed(() => useMq().current === "xs");
const parsedHash = computed(() =>
  tx.value.Hash === undefined
    ? ""
    : `${tx.value.Hash.substr(0, 8)}...${tx.value.Hash.substr(58, 8)}`
);
const parsedFrom = computed(() =>
  tx.value.From === undefined
    ? ""
    : `${tx.value.From.substr(0, 8)}...${tx.value.From.substr(34, 8)}`
);
const parsedTo = computed(() =>
  tx.value.To === undefined
    ? ""
    : `${tx.value.To.substr(0, 8)}...${tx.value.To.substr(34, 8)}`
);

onMounted(async () => {
  await getTransaction();
  IsLoading.value = false;
});

const route = useRoute();
const router = useRouter();

const getTransaction = async () => {
  const res = await getTx({
    Hash: route.params.Hash,
  });
  tx.value = res;
};

const copyDetailVal = () => {
  const clipboard = new Clipboard(".copy-success");
  clipboard.on("success", function (e) {
    e.clearSelection();
  });
  copied();
};
const copied = () => {
  ElMessage(t.message.copysuccess);
};

const toBlock = (number: number) => {
  router.push({ name: "Block", params: { Number: number } });
};
const toNft = (contractAddress: string, tokenNumber: number) => {
  router.push({
    name: "NFTTokenDetail",
    params: { NFT: contractAddress, Token: tokenNumber },
  });
};
const toContract = (contractAddress: string) => {
  router.push({
    name: "ContractDetail",
    params: {
      Contract: contractAddress,
    },
  });
};
const toAddress = (address: string) => {
  router.push({
    name: "UserTxs",
    params: {
      User: address.toLowerCase(),
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Title, {
        title: _ctx.$t('tx.name')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("tx.txhash")) + ":", 1),
        _createElementVNode("div", _hoisted_6, [
          (_unref(isSmOrXs))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(parsedHash)), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(tx.value.Hash), 1)
              ])),
          _createVNode(_unref(ElIcon), { size: 16 }, {
            default: _withCtx(() => [
              _createVNode(_unref(CopyDocument), {
                size: 16,
                class: "el-icon-copy-document copy-success",
                "data-clipboard-target": "#detailVal1",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (copyDetailVal()))
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(tx.value.Hash), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("tx.status")) + ":", 1),
        (!IsLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (tx.value.Status === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("tx.success")), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("tx.failed")), 1)
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("tx.block")) + ":", 1),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", {
            class: "text clickable",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (toBlock(tx.value.BlockNumber)))
          }, _toDisplayString(_unref(HelperTools).toFinancialVal(tx.value.BlockNumber)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("tx.time")) + ":", 1),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(HelperTools).getTransDate(tx.value.Time)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("tx.from")) + ":", 1),
        _createElementVNode("div", _hoisted_33, [
          (_unref(isXs))
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(parsedFrom)), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("span", _hoisted_37, _toDisplayString(tx.value.From), 1)
              ])),
          _createVNode(_unref(ElIcon), { size: 16 }, {
            default: _withCtx(() => [
              _createVNode(_unref(CopyDocument), {
                size: 16,
                class: "el-icon-copy-document copy-success",
                "data-clipboard-target": "#detailVal2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (copyDetailVal()))
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("span", _hoisted_39, _toDisplayString(tx.value.From), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("tx.to")) + ":", 1),
        _createElementVNode("div", _hoisted_42, [
          (_unref(isXs))
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(parsedTo)), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createElementVNode("span", _hoisted_46, _toDisplayString(tx.value.To), 1)
              ])),
          _createVNode(_unref(ElIcon), { size: 16 }, {
            default: _withCtx(() => [
              _createVNode(_unref(CopyDocument), {
                size: 16,
                class: "el-icon-copy-document copy-success",
                "data-clipboard-target": "#detailVal3",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (copyDetailVal()))
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("span", _hoisted_48, _toDisplayString(tx.value.To), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t("tx.gas")) + ":", 1),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("span", _hoisted_52, _toDisplayString(_unref(HelperTools).toFinancialVal(tx.value.Gas)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t("tx.price")) + ":", 1),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("span", _hoisted_56, _toDisplayString(tx.value.GasPrice), 1)
        ])
      ]),
      (tx.value.TransactionDetails)
        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t("tx.details")) + ":", 1),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tx.value.TransactionDetails, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "detail-list-item",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t("tx.from")), 1),
                        _createElementVNode("div", {
                          class: "content",
                          onClick: ($event: any) => (toAddress(item.From))
                        }, [
                          (_unref(isXs))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                _createElementVNode("span", _hoisted_65, _toDisplayString(item.From.substr(0, 4)) + "..." + _toDisplayString(item.From.substr(40, 2)), 1)
                              ]))
                            : (_unref(isMdOrSm))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                  _createElementVNode("span", _hoisted_67, _toDisplayString(item.From.substr(0, 8)) + "..." + _toDisplayString(item.From.substr(34, 8)), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                  _createElementVNode("span", _hoisted_69, _toDisplayString(item.From), 1)
                                ]))
                        ], 8, _hoisted_63)
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.$t("tx.to")), 1),
                        _createElementVNode("div", {
                          class: "content",
                          onClick: ($event: any) => (toAddress(item.To))
                        }, [
                          (_unref(isXs))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                _createElementVNode("span", _hoisted_74, _toDisplayString(item.To.substr(0, 4)) + "..." + _toDisplayString(item.To.substr(40, 2)), 1)
                              ]))
                            : (_unref(isMdOrSm))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                  _createElementVNode("span", _hoisted_76, _toDisplayString(item.To.substr(0, 8)) + "..." + _toDisplayString(item.To.substr(34, 8)), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                  _createElementVNode("span", _hoisted_78, _toDisplayString(item.To), 1)
                                ]))
                        ], 8, _hoisted_72)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, _toDisplayString(item.IsNft && item.TokenInfo && item.TokenInfo.Token
                        ? _ctx.$t("tx.tokenId")
                        : _ctx.$t("tx.for")), 1),
                        _createElementVNode("div", {
                          class: "content",
                          onClick: ($event: any) => (
                      item.IsNft && item.TokenInfo && item.TokenInfo.Token
                        ? toNft(item.Contract, item.TokenInfo.Token)
                        : null
                    )
                        }, [
                          (_unref(isXs))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                _createElementVNode("span", _hoisted_84, _toDisplayString(_unref(HelperTools).toFinancialVal(item.Value).substr(0, 5)), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(
                          item.IsNft && item.TokenInfo && item.TokenInfo.Token
                            ? 'text link'
                            : 'text'
                        )
                                }, _toDisplayString(item.IsNft && item.TokenInfo && item.TokenInfo.Token
                            ? item.TokenInfo.Token
                            : `${_unref(HelperTools).toFinancialVal(item.Value)} 
                              ${item.ContractInfo.Symbol}`), 3)
                              ]))
                        ], 8, _hoisted_82)
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", {
                          class: "content",
                          onClick: ($event: any) => (toContract(item.Contract))
                        }, [
                          (_unref(isXs))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                _createElementVNode("span", _hoisted_89, " [" + _toDisplayString(item.Contract.substr(0, 4)) + "..." + _toDisplayString(item.Contract.substr(40, 2)) + "] ", 1)
                              ]))
                            : (_unref(isMdOrSm))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                  _createElementVNode("span", _hoisted_91, " [" + _toDisplayString(item.Contract.substr(0, 8)) + "..." + _toDisplayString(item.Contract.substr(36, 8)) + "] ", 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                  _createElementVNode("span", _hoisted_93, " [" + _toDisplayString(item.Contract) + "] ", 1)
                                ]))
                        ], 8, _hoisted_87)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})